import React from 'react';
import AuthForm from './auth-form.jsx';
import AuthShell from './auth-shell.jsx';

function AuthWithImageSignUp() {
	return <AuthShell variant="with-image"><AuthForm variant="with-image" mode="sign-up" /></AuthShell>;
}

export default AuthWithImageSignUp;
